export const SIDEBAR_LOAD = "SIDEBAR_LOAD";
export const SIDEBAR_LOAD_SUCCESS = "SIDEBAR_LOAD_SUCCESS";
export const SIDEBAR_LOAD_FAIL = "SIDEBAR_LOAD_FAIL";
export const SIDEBAR_LOAD_COLLECTION = "SIDEBAR_LOAD_COLLECTION";
export const SIDEBAR_LOAD_COLLECTION_SUCCESS = "SIDEBAR_LOAD_COLLECTION_SUCCESS";
export const SIDEBAR_LOAD_COLLECTION_FAIL = "SIDEBAR_LOAD_COLLECTION_FAIL";
export const SET_LINK = "SET_LINK";
export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";

export default function sidebar(
  state = {
    data: [],
    dataCollection: [],
    isLoading: true,
    hasErrored: false,
    errorMessage: "",
    url: null,
    open: false,
    paths: null,
  },
  action,
) {
  switch (action.type) {
    case SIDEBAR_LOAD: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case SIDEBAR_LOAD_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        errorMessage: action.error.message,
        hasErrored: true,
      });
    }

    case SIDEBAR_LOAD_SUCCESS: {
      // eslint-disable-next-line no-console
      console.log("[sidebar] SIDEBAR_LOAD_SUCCESS → items recibidos del back", {
        timestamp: new Date().toISOString(),
        items: action.payload.data?.data,
        paths: action.payload.data?.paths,
      });

      return Object.assign({}, state, {
        data: action.payload.data?.data,
        paths: action.payload.data?.paths,
        isLoading: false,
        hasErrored: false,
      });
    }

    case SET_LINK: {
      return Object.assign({}, state, {
        url: action.payload,
      });
    }

    case OPEN_SIDEBAR: {
      return Object.assign({}, state, {
        open: true,
      });
    }

    case CLOSE_SIDEBAR: {
      return Object.assign({}, state, {
        open: false,
      });
    }

    default:
      return state;
  }
}

export function getSideBarItems() {
  // eslint-disable-next-line no-console
  console.log("[sidebar] dispatching getSideBarItems → GET MenuItem/Grouped", {
    timestamp: new Date().toISOString(),
  });

  return {
    type: SIDEBAR_LOAD,
    payload: {
      request: {
        url: "MenuItem/Grouped",
      },
    },
  };
}

/**
 * Action to request Menu Items of Layout
 * @param {string} name - name of Layout
 */
export function sidebarFetchMenuItemsByLayout(name) {
  return {
    type: SIDEBAR_LOAD,
    payload: {
      request: {
        url: "MenuItem/Layout/" + name,
      },
    },
  };
}

export function sidebarFetchMonthlyData() {
  return {
    type: SIDEBAR_LOAD,
    payload: {
      request: {
        url: "/data/monthlysidebar.json",
      },
    },
  };
}

export function openSidebar() {
  return {
    type: OPEN_SIDEBAR,
  };
}

export function closeSidebar() {
  return {
    type: CLOSE_SIDEBAR,
  };
}
